export default __webpack_public_path__ + "static/media/remoteclinic.99d16b41.jpg";